import { render, staticRenderFns } from "./dashujuDetails.vue?vue&type=template&id=f0518eaa"
import script from "./dashujuDetails.vue?vue&type=script&lang=js"
export * from "./dashujuDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports